import { render, staticRenderFns } from "./FooterComponentJnjtseu.vue?vue&type=template&id=49780d19&scoped=true"
import script from "./FooterComponentJnjtseu.vue?vue&type=script&lang=ts"
export * from "./FooterComponentJnjtseu.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentJnjtseu.vue?vue&type=style&index=0&id=49780d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49780d19",
  null
  
)

export default component.exports